import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {boothFetch, authorFeedFetch} from '../../../actions/index';
// import style from './style.css';
import {gtmSend} from '../../../helpers';
import Loader from '../../../components/Common/Loader';
import MemoryElemContainer from '../Elems/MemoryElem';
import EmptyPlaceholder from '../../../components/Misc/EmptyPlaceholder';
import { translate } from 'react-i18next';
import cx from '../../../styles';

/**
 * This container is never used directly. If you are looking for feed landing pages, check Page Container
 */
class BoothFeedContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {eof: false};
    }

    componentDidMount() {
        //in case parent element does not fill feed
        // if(!this.props.boothReducer.boothList.length && !this.props.boothReducer.ifInfiniteLoading){
        //     this.props.boothFetch(this.props.boothReducer.currentFeed, this.props.boothReducer.page, true, '/', this.props.boothReducer.filter);
        // }
        //add scroll handler
        if(typeof window != 'undefined'){
            window.addEventListener("scroll", this.bindScrollEvent);
        }
    }

    componentWillUnmount() {
        //add scroll handler
        if(typeof window != 'undefined'){
            window.removeEventListener("scroll", this.bindScrollEvent);
        }
    }

    bindScrollEvent = () => {
        if(window.scrollY >= document.body.scrollHeight - window.innerHeight - 500) {
           if(!this.props.boothReducer.ifInfiniteLoading) this.infiniteScrollHandler();
        }
    }

    infiniteScrollHandler = () => {
        //add elems
        const page = ++this.props.boothReducer.page;
        if(this.props.subType && this.props.subType == 'hash') {
            if(this.state.eof) return false;
            gtmSend('infinite scroll', 'memories', 'scroll:hash', page);
            let nextLength;
            const prevLength = this.props.boothReducer.boothList.length;            
            this.props.boothHashtagFetch(this.props.boothReducer.hashtag, page, false, this.props.location.pathname ,this.props.boothReducer.filter)
            .then(() => {
                nextLength = this.props.boothReducer.boothList.length;
                if(prevLength == nextLength) {
                    this.setState({eof: true});
                }
            });
        } else if(this.props.subType && this.props.subType == 'author') {
            gtmSend('infinite scroll', 'author', 'scroll:booth', page);
            this.props.authorFeedFetch(this.props.boothReducer.currentFeed, page, this.props.feedReducer.author.id, false, this.props.location.pathname,this.props.feedReducer.filter);
        } else {
            gtmSend('infinite scroll', 'memories', `scroll:${this.props.boothReducer.currentFeed}`, page);
            this.props.boothFetch(this.props.boothReducer.currentFeed, page, false, this.props.location.pathname ,this.props.boothReducer.filter);
        }
    }

    render() {
        const {boothReducer} = this.props,
            finalFeed = boothReducer.boothList.map((data, i) => {
                return <MemoryElemContainer key={i}
                        index={i}
                        inFeed={true}
                        type={'booth'}
                        id={data.booth.id}
                        match={this.props.match}
                        subType={this.props.subType}
                        data={data} />;
            });

        return (
            <div className={cx("feed", "photo-booth-grid", boothReducer.boothList.length == 0 ? "no-photos" : "")} ref="iScroll">
                { 
                    boothReducer.boothList.length
                    ? finalFeed
                    : <EmptyPlaceholder content={this.props.t('search_empty')} />
                }
                { boothReducer.ifInfiniteLoading && <Loader /> }
            </div>
        );
    }

}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        boothFetch,
        authorFeedFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(BoothFeedContainer));
